import {
  band,
  breakpoints,
  Col,
  gradientStyle,
  Text,
  type TextStyle,
  useTheme,
  type ViewStyle,
} from "@rally/ui-kit";
import { say } from "./localization/say.ts";

const TIMES = 3.4;
const SMALL = 22;

export const UNDER_THE_BRAND = band.height;

export const THE_PHONE_BAND = band.heightNarrow;

export const columnPad = (narrow: boolean): number => (narrow ? band.edgeNarrow : band.edge);

const LINE = 26;

export function Brand({
  big = false,
  within,
}: {
  big?: boolean;
  within?: { width: number; height: number };
}) {
  const theme = useTheme();

  const narrow = theme.isAtMost(breakpoints.phone);
  const restingLeft = columnPad(narrow);
  const restingTop = narrow ? theme.space[4] : theme.space[6];
  const grown = big && within && within.width > 0;

  const Wide = 194;

  const times = narrow ? 2 : TIMES;

  const across = 0.36;
  const travel: ViewStyle = grown
    ? {
        transform: narrow
          ? [
              { translateX: (within.width - Wide) / 2 - restingLeft },
              { translateY: Math.max(0, (within.height - LINE * times) / 2 - restingTop) },
              { scale: times },
            ]
          : [
              { translateX: (within.width - restingLeft * 2) * across - 66 },
              { translateY: within.height / 2 - restingTop - 78 },
              { scale: times },
            ],
      }
    : { transform: [{ translateX: 0 }, { translateY: 0 }, { scale: 1 }] };
  return (
    <Col
      testID="brand"
      style={
        {
          position: "absolute",

          left: big ? restingLeft : 0,

          top: grown ? restingTop : 0,
          bottom: grown ? undefined : 0,
          justifyContent: "center",
          transformOrigin: "left top",
          transitionProperty: "transform",
          transitionDuration: theme.preferReduced ? "0ms" : "460ms",
          transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
          ...travel,
        } as ViewStyle
      }
    >
      <Col style={{ alignItems: "flex-start" }}>
        <Col style={{ flexDirection: "row", alignItems: "center", gap: theme.space[2] }}>
          <Col
            style={{
              width: SMALL + 6,
              height: SMALL + 6,
              borderRadius: 999,
              alignItems: "center",
              justifyContent: "center",
              ...gradientStyle("#0b72e7", "#4f9df0"),
            }}
          >
            <Text
              style={
                {
                  fontFamily: "var(--rally-brand)",
                  fontSize: SMALL - 4,
                  lineHeight: SMALL - 2,
                  color: "#ffffff",
                } as TextStyle
              }
            >
              R
            </Text>
          </Col>
          <Text
            style={
              {
                fontFamily: "var(--rally-brand)",
                fontSize: SMALL,
                lineHeight: 26,
                fontWeight: "600",
                letterSpacing: -0.2,

                backgroundImage: `linear-gradient(100deg, ${theme.color["text.primary"]} 0em, ${theme.color.accentGradient[1]} 4.6em)`,
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                color: "transparent",
              } as TextStyle
            }
          >
            Rally
          </Text>
        </Col>
        {grown ? (
          <Text
            style={
              {
                fontFamily: theme.font.sans,

                fontSize: SMALL * 0.25,
                lineHeight: SMALL * 0.38,
                letterSpacing: 0.3,
                fontWeight: "500",
                color: theme.color["text.tertiary"],
                marginTop: 3,

                marginLeft: SMALL + theme.space[2],
              } as TextStyle
            }
          >
            {say("brand.tagline")}
          </Text>
        ) : null}
      </Col>
    </Col>
  );
}
